import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
import Select from "react-select";
import moment from 'moment';


function OpenPopUp({modal, handleShow, mode, certificate, errorMessage, successMessage, formattedCertificateData,selectedCertificates, setSelectedCertificates,formattedProductsData, assignCertificate,
    selectedProducts ,setSelectedProducts, isEditAction
}) {


    // Function for handle selected certificate
    const handleCertificationSelectChange = (selected) => {     
      setSelectedCertificates(selected)
    };

    // Function for handle selected certificate
    const handleProductSelectChange = (selected) => {      
      setSelectedProducts(selected)
    };


    
    
    
    
  return (
    <Modal size={'md'}  isOpen={modal} toggle={handleShow}>
     {mode == 'ADD_CERTIFICATE' && <Form onSubmit={certificate.handleSubmit}>
        <ModalBody className="p-5">
            <Row>
              <Col>
              {errorMessage && (
                <span className=" invalidError d-flex justify-content-center">
                  {errorMessage}
                </span>
              )}
              {successMessage && (
                <span className=" successMsg d-flex justify-content-center">
                  {successMessage}
                </span>
              )}
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                    <Label htmlFor="certificateId">Certificate Id:</Label>
                    <Input
                      type="text"
                      value={certificate.values.certificate_id}
                      required
                      onChange={certificate.handleChange}
                      id="certificateId"
                      name="certificate_id"
                    />
                    {certificate.errors.certificate_id ||
                      certificate.touched.certificate_id ? (
                      <div className=" invalidError d-flex justify-content-center">
                          {certificate.errors.certificate_id}
                      </div>
                    ) : null}
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                    <Label htmlFor="certificateName">Name:</Label>
                    <Input
                      type="text"
                      value={certificate.values.name}
                      required
                      onChange={certificate.handleChange}
                      id="certificateName"
                      name="name"
                    />
                </FormGroup>
              </Col>
            </Row>

        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">
            Submit
          </Button>
          <Button color="danger" onClick={handleShow}>
            Close
          </Button>
        </ModalFooter>
     </Form>}
     {mode == 'ASSIGN_CERTIFICATE' && <Form onSubmit={assignCertificate.handleSubmit}>
        <ModalBody className="p-5">
            <Row>
              <Col>
              {errorMessage && (
                <span className=" invalidError d-flex justify-content-center">
                  {errorMessage}
                </span>
              )}
              {successMessage && (
                <span className=" successMsg d-flex justify-content-center">
                  {successMessage}
                </span>
              )}
              </Col>
            </Row>
              <>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                        <Label htmlFor="certificateType">Certificates:</Label>
                        <Select
                            // className="w-75"
                            value={selectedCertificates}
                            options={formattedCertificateData}
                            placeholder="Select a certificate"
                            isDisabled={isEditAction}
                            isSearchable
                            onChange={handleCertificationSelectChange}
                        />
                        {assignCertificate.errors.certificate_id ||
                         assignCertificate.touched.certificate_id ? (
                          <div className=" invalidError d-flex justify-content-center">
                              {assignCertificate.errors.certificate_id}
                          </div>
                        ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup>
                    <Label htmlFor="products">Select products:</Label>
                    <Select
                      value={selectedProducts}
                      options={formattedProductsData}
                      placeholder="Select a product"
                      isSearchable
                      isDisabled={isEditAction}
                      onChange={handleProductSelectChange}
                    />
                    {assignCertificate.errors.product_id &&
                      assignCertificate.touched.product_id ? (
                      <div className=" invalidError d-flex justify-content-center">
                        {assignCertificate.errors.product_id}
                      </div>
                    ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="CertificateFile">Certification:</Label>
                    <Input
                        type="file"
                        onChange={(event) =>
                          assignCertificate.setFieldValue(
                            "certification_file",
                            event.currentTarget.files[0]
                          )
                        }
                        disabled={isEditAction}
                        id="CertificateFile"
                        name="certification_file"
                      />
                    </FormGroup>
                  </Col>
                   <>
                    <Col md={6}>
                    <FormGroup>
                      <Label htmlFor="certificateStartDate">Start Date:</Label>
                      <Input
                        type="date"
                        value={assignCertificate.values.start_date || ""}
                        onChange={assignCertificate.handleChange}
                        id="certificateStartDate"
                        name="start_date"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label htmlFor="certificateEndDate">End Date:</Label>
                      <Input
                        type="date"
                        value={assignCertificate.values.end_date || ""}
                        onChange={assignCertificate.handleChange}
                        id="certificateEndDate"
                        name="end_date"
                        min={assignCertificate.values.start_date || moment().format('YYYY-MM-DD')} // Corrected min date logic
                      />
                    </FormGroup>
                  </Col>
                   </>
           

                </Row>
              </>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">
            Submit
          </Button>
          <Button color="danger" onClick={handleShow}>
            Close
          </Button>
        </ModalFooter>
     </Form>}

     {mode == 'VIEW_PRODUCT_RELATE_CERTIFICATIONS' && (
      <>
        <ModalBody className="p-5">
            <h1>Welcome</h1>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleShow}>
            Close
          </Button>
        </ModalFooter>
      </>
     )}
  </Modal>
  )
}

export default OpenPopUp
